import { TAffairKind } from "@api/affair.int";
import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea, useToast } from "@chakra-ui/react";
import { CardContentHead1, VizvButtonPrimary, VizvCardHeader } from "components/vizvComponents";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaCopy } from "react-icons/fa";


export function AffairCreatePanaszSablon({ showKind, onClose }: { showKind?: TAffairKind, onClose: () => void }) {

	const toast = useToast();
	const onCopy = () => {
		toast({
			title: 'A szöveget a vágólapra másoltuk.'
		})
	}
	let szoveg = `(${showKind} esetére még nincs minta)`;

	if (showKind === 'csotores')
		szoveg = `Tisztelt Szolgáltató!

Ezúton írásban jelzem, hogy a 202……………-én, a …………….. órákban csőtörést tapasztaltam az alábbi helyszínen:

……………………………………………………………..

Tisztelettel várom intézkedésüket a szolgáltatás helyreállítása érdekében.

Üdvözlettel (Név, Cím, Dátum)
`

	if (showKind === 'vizminoseg')
		szoveg = `Tisztelt Szolgáltató!

Ezúton írásban jelzem, hogy a 202……………-én, a …………….. órákban szolgáltatott víz minősége ellen panasszal kívánok élni. A szolgáltatott víz zavaros, jelentős lebegő-, és ülepedő anyagot tartalmaz, bűzös, így bizonyosan nem felel meg a 201/2001 Korm. rendelet 1. mellékletének C táblázatában található szín, szag, íz és zavarosság jellemzőkhöz megadott paramétereknek.

Tisztelettel várom kompenzációs, vagy egyéb javaslatukat, valamint intézkedésüket a szolgáltatás minőségének javítása érdekében.

Üdvözlettel (Név, Cím, Dátum)
`;


	return <Modal isOpen={!!showKind} onClose={onClose} >
		<ModalOverlay />
		<ModalContent bg='cardbg.popup' >
			<ModalHeader >
				<ModalCloseButton />
				<VizvCardHeader fontSize='xl' boxShadow='lg' mt={1} isModal>Panaszlevél</VizvCardHeader>
				<CardContentHead1>Minta:</CardContentHead1>
			</ModalHeader>
			<ModalBody>
				<Textarea isReadOnly={true} defaultValue={szoveg} rows={18} />
			</ModalBody>
			<ModalFooter>
				<CopyToClipboard text={szoveg}
					onCopy={onCopy}>
					<Button leftIcon={<FaCopy />}
					>Vágólapra másolom</Button>
				</CopyToClipboard>
			</ModalFooter>
		</ModalContent>
	</Modal>
}